<template>
	<div>
		<!-- <uiLoader v-if="saving" />
		<uiFold
			title="Создать запись"
			openedTitle="Закрыть"
			:small="true"
			ref="createFold"
			@click="editedEvent = null"
			v-else
		>
			<PetEventCreate
				:initial="editedEvent"
				@remove="removeEvent"
				@save="saveEvent"
			/>
		</uiFold>

		<uiBlockTitle :small="true">Записи</uiBlockTitle>
		<template v-if="future.length">
			<PetEventsGroup :events="future" @click="editEvent" />
		</template>
		<div class="nope" v-else>
			Записей нет
		</div>

		<uiDevider /> -->

		<uiBlockTitle :small="true">История</uiBlockTitle>
		<PetEventsGroup :events="allEvents" @click="editEvent" />

		<uiButton color="light" v-if="canLoadHistory" @click="loadHistory(allEvents.at(-1)?.date)">
			Загрузить
		</uiButton>
	</div>
</template>

<script>
import PetEventsGroup from '@/components/PetEventsGroup'
import PetEventCreate from '@/components/PetEventCreate'
import { API } from '@/config'
import { format, formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'

export default {
	name: 'PetEvents',
	components: {
		PetEventsGroup,
		PetEventCreate,
	},
	props: {
		petId: String,
	},
	data() {
		return {
			loadingFuture: false,
			loadingHistory: false,
			saving: false,
			future: [],
			history: [],
			noMoreHistory: false,
			editedEvent: null,
		}
	},
	computed: {
		canLoadHistory() {
			return !this.noMoreHistory
		},
		allEvents() {
			return [...this.future, ...this.history]
				.sort((a, b) => new Date(b.date) - new Date(a.date))
		}
	},
	watch: {
		petId() {
			this.future = []
			this.history = []
			this.loadFuture()
			this.loadHistory()
		},
	},
	created() {
		this.loadFuture()
		this.loadHistory()
		this.$events.$on('syncPetEvents', this.syncPetEvents)
	},
	destroyed() {
		this.$events.$off('syncPetEvents', this.syncPetEvents)
	},
	methods: {
		editEvent(e) {
			this.editedEvent = e
			this.$refs.createFold?.open()
		},
		async syncPetEvents(e) {
			if (this.petId !== e.pet) return
			this.loadFuture()
			this.loadHistory()
		},
		async loadFuture() {
			if (this.loadingFuture) return
			this.loadingFuture = true

			let url = API.EVENTS.future
			let { data } = await this.$http.post(url, { petId: this.petId })
			if (!data || data.err) this.$notify(data.err)
			if (data) this.future = data
			this.loadingFuture = false
		},
		async loadHistory(before) {
			if (this.loadingHistory) return
			this.loadingHistory = true

			let url = API.EVENTS.history
			let { data } = await this.$http.post(url, {
				petId: this.petId,
				beforeId: before,
			})
			if (!data || data.err) this.$notify(data.err)
			if (data) {
				if (before) this.history = [...this.history, ...data]
				else this.history = data
			}

			if (data.length < 30) this.noMoreHistory = true
			this.loadingHistory = false
		},
		async saveEvent(e) {
			if (this.saving) return
			this.$refs.createFold.close()
			this.editedEvent = null
			this.saving = true

			e.pet = this.petId

			let { data } = await this.$http.post(API.EVENTS.update, e)
			if (!data || data.err) {
				this.$notify(data.err)
				this.saving = false
				this.$refs.createFold.close()
				this.editedEvent = e
				return
			}

			this.saving = false
		},
		async removeEvent(e) {
			if (this.saving) return

			let confirm = await this.$confirm('Точно удаляем?')
			if (!confirm) return

			this.$refs.createFold.toggle()
			this.editedEvent = null
			this.saving = true

			e.pet = this.petId

			let { data } = await this.$http.post(API.EVENTS.remove, e)
			if (!data || data.err) this.$notify(data.err)
			this.saving = false
		},
		formatDate(d) {
			return format(new Date(d), 'dd.MM.yyyy в HH:mm')
		},
		distance(d) {
			return formatDistanceToNow(new Date(d), { locale: ru })
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.disabled {
	opacity: 0.3;
	pointer-events: none;
}

.nope {
	text-align: center;
	padding: 10px 0;
	opacity: 0.5;
}
</style>
